export default __webpack_public_path__ + "static/media/category_program_h.5352b234.svg";